var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"m-slider",staticStyle:{"height":"60px","width":"100%"},on:{"mouseenter":_vm.onStop,"mouseleave":_vm.onStart}},[_c('img',{staticClass:"img",attrs:{"src":require('../../assets/images/trumpet.png'),"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }